import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _createClass from "@babel/runtime/helpers/createClass";
import _inherits from "@babel/runtime/helpers/inherits";
import _possibleConstructorReturn from "@babel/runtime/helpers/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/getPrototypeOf";

var _dec, _class;

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { browserHistory } from 'react-router';
import { connect } from 'react-redux';
import Helmet from 'react-helmet';
import { Preview } from 'containers/ReportBuilder';
import { loadReport } from 'redux/modules/reportBuilder';
var ReportPdfRender = (_dec = connect(function (state) {
  return {
    reportsById: state.reportBuilder.reportsById
  };
}, {
  loadReport: loadReport
}), _dec(_class = /*#__PURE__*/function (_Component) {
  _inherits(ReportPdfRender, _Component);

  var _super = _createSuper(ReportPdfRender);

  function ReportPdfRender(props) {
    var _this;

    _classCallCheck(this, ReportPdfRender);

    _this = _super.call(this, props);
    _this.state = {
      orgId: null
    };
    return _this;
  }

  _createClass(ReportPdfRender, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      var _this2 = this;

      this.props.loadReport(null, this.props.location.query.rid, this.props.location.query.t, this.props.location.query.env).then(function (res) {
        _this2.setState({
          orgId: res.data.OrganizationId
        });
      });
    }
  }, {
    key: "render",
    value: function render() {
      return /*#__PURE__*/React.createElement("div", {
        style: {
          margin: '3rem'
        },
        id: "report-root"
      }, /*#__PURE__*/React.createElement("style", {
        dangerouslySetInnerHTML: {
          __html: "html {\n          height: auto !important;\n        }"
        }
      }), this.state.orgId && /*#__PURE__*/React.createElement(Preview, {
        reportView: true,
        reportType: this.props.reportsById[this.state.orgId][this.props.location.query.rid].reportType,
        template: this.props.reportsById[this.state.orgId][this.props.location.query.rid]
      }));
    }
  }]);

  return ReportPdfRender;
}(Component)) || _class);
export { ReportPdfRender as default };